import { Component, EventEmitter, Input, Output } from '@angular/core';
import { buildVesCashoutDraft } from '../cashout-draft-builders';
import { CashoutDraft } from '../cashout-currency.types';

@Component({
  selector: 'app-ves-form',
  templateUrl: './ves-form.component.html',
  styleUrl: '../../add-cashout.component.scss',
})
export class VesFormComponent {
  @Input() ctx!: any;
  @Output() draftReady = new EventEmitter<CashoutDraft>();

  saveTransaction(): void {
    const draft = buildVesCashoutDraft(this.ctx);
    if (draft) {
      this.draftReady.emit(draft);
    }
  }
}
